import { useRouter } from "vue-router";
import { defineComponent, reactive, ref } from "vue";
import { showNotify } from "vant";
import { addVistor } from "@/api/visitor";
import { validIdCard, validPhone, validLicense } from "@/utils/valid";
// 校验身份证号
const validCard = val => validIdCard(val, true);
// 校验车牌号
const valLicense = val => validLicense(val, true);
export default defineComponent({
  name: "VisitorAdd",
  setup() {
    const router = useRouter();
    ;
    let modelForm = reactive({
      name: "",
      phone: "",
      cardId: "",
      beginTime: "",
      endTime: "",
      visitorNum: "1",
      visitReason: "",
      license: "",
      photoPath: ""
    });
    let showPicker = ref(false);
    // 显示日期选择组件
    let field = ""; // 赋值字段
    const handlerClcikTime = fieldName => {
      field = fieldName;
      showPicker.value = true;
    };
    const dateChange = res => {
      modelForm[field] = res;
    };
    const loading = ref(false);
    const onSubmit = values => {
      if (new Date(modelForm.beginTime).getTime() >= new Date(modelForm.endTime).getTime()) {
        showNotify({
          type: "danger",
          message: "开始时间不能大于等于结束时间"
        });
        return;
      }
      loading.value = true;
      addVistor(modelForm).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          router.go(-1);
          showNotify({
            type: "success",
            message: msg
          });
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    return {
      modelForm,
      validCard,
      validPhone,
      valLicense,
      showPicker,
      dateChange,
      handlerClcikTime,
      loading,
      onSubmit
    };
  }
});